import { useState } from 'react'
import { mapCertIdToApi } from '../services/gon-service'
import { deleteCertificationQuery, saveCertificationQuery } from '../services/CertificationService'
import { STEMCELL_CERTIFICATION } from '../components/products/constants'

export default function useCertifications({ draftId, product }) {
  const [certifications, setCertifications] = useState(product.certifications)

  const onAddStemcellCertification = (certification) => {
    setCertifications((prevCerts) => ({
      ...prevCerts,
      [certification]: {
        id: certification,
        submitted: true,
      },
    }))
  }

  const onRemoveStemcellCertification = (certification) => {
    const { [certification.id]: value, ...remainingCerts } = certifications
    setCertifications(() => remainingCerts)
  }

  const onAddCertification = async (certification) => {
    await saveCertificationQuery({
      draftId,
      body: { id: mapCertIdToApi(certification) }
    })

    setCertifications(prevCerts => ({
      ...prevCerts,
      [certification]: {
        id: certification,
        submitted: true
      }
    }))
  }

  const onRemoveCertification = async (certification) => {
    await deleteCertificationQuery({ draftId }, mapCertIdToApi(certification))

    setCertifications(prevCerts => {
      const { [certification]: removedCertification, ...remainingCertifications } = prevCerts
      return remainingCertifications
    })
  }

  return {
    certifications,
    isStemcellCertified: !!certifications[STEMCELL_CERTIFICATION],
    onAddStemcellCertification,
    onRemoveStemcellCertification,
    onAddCertification,
    onRemoveCertification,
  }
}
